import _ from 'lodash'
import { useEffect, useState } from 'react'
import styled from 'styled-components'
import { v1 as generateUUID } from 'uuid'

import { WordWraps } from 'common-components'
import MESSAGES from 'core/data-model/constants/messages'
import { isRequiredLicenses } from 'core/service/display-product'
import { isCurrentDateInRange } from 'core/service/lib/date'
import { getServiceWrapper } from 'core/service-wrapper'
import { toDataURL } from 'e-submission/utils'

const ProductImage = styled(({ src, ...props }) => <div {...props} />)`
  background-image: url('${({ src }) => src}');
`

const ProductImageExternal = ({ className, src, isSelected, children }) => {
  const [srcContent, setSrcContent] = useState('')
  const [loading, setLoading] = useState(true)
  const elmId = generateUUID()

  useEffect(async () => {
    const result = await toDataURL(src, { cache: 'force-cache' })
    if (result) {
      setSrcContent(result)
    }

    setLoading(false)
  }, [])

  useEffect(() => {
    if (srcContent.length) {
      const canvas = document.createElement('canvas')
      canvas.style.position = 'absolute'
      canvas.style.top = '0'
      canvas.style.left = '0'
      canvas.style.width = '100%'
      canvas.style.height = '100%'

      const ctx = canvas.getContext('2d')

      const image = new Image()
      image.onload = () => {
        const cardImage = document.getElementById(elmId)
        const cardImageCStyle = window.getComputedStyle(cardImage)

        canvas.width = parseFloat(cardImageCStyle.width)
        canvas.height = parseFloat(cardImageCStyle.height)

        const { offsetX, offsetY, width, height } = getImageSize(ctx, image)
        ctx.drawImage(image, offsetX, offsetY, width, height)

        cardImage.appendChild(canvas)
      }
      image.src = srcContent
    }
  }, [loading])

  function getImageSize(context, image) {
    let canvasWidth = context.canvas.width,
      canvasHeight = context.canvas.height,
      canvasRatio = canvasHeight / canvasWidth,
      imageWidth = image.naturalWidth,
      imageHeight = image.naturalHeight,
      imageRatio = imageHeight / imageWidth,
      widthValue = imageRatio > canvasRatio ? canvasWidth : canvasHeight / imageRatio,
      heightValue = imageRatio > canvasRatio ? canvasWidth * imageRatio : canvasHeight,
      adjX = imageRatio > canvasRatio ? 0 : (canvasWidth - widthValue) / 2,
      adjY = imageRatio > canvasRatio ? (canvasHeight - heightValue) / 2 : 0

    return {
      width: widthValue,
      height: heightValue,
      offsetX: adjX,
      offsetY: adjY,
    }
  }

  if (loading) {
    return (
      <div
        className="product-image"
        style={{ position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
      >
        <div className="spinner" style={{ position: 'absolute' }}></div>
      </div>
    )
  }

  return (
    <div id={elmId} className={className} style={{ position: 'relative' }}>
      {children}
      {isSelected && <div className={'ticked'} />}
    </div>
  )
}

const OrdinaryForceLoginIcon = (displayProduct) => {
  const serviceWrapper = getServiceWrapper()
  return displayProduct.category !== 'INVESTMENT' && serviceWrapper.isOrdinaryForceLoginProduct(displayProduct)
}

const shouldShowRibbonMessage = (ribbonMessage) => {
  if (!ribbonMessage || _.isEmpty(ribbonMessage.text)) return false
  if (_.isEmpty(ribbonMessage.startDate) || _.isEmpty(ribbonMessage.endDate)) return true

  const inRange = isCurrentDateInRange(ribbonMessage.startDate, ribbonMessage.endDate)
  return inRange
}

export const BasicPlanSummary = ({ displayProduct, isBrochure = false }) => {
  const displayName = _.get(displayProduct, 'displayName', '')
  const requireLicenses = isRequiredLicenses(displayProduct)
  const isShowIconCheckLicenses = OrdinaryForceLoginIcon(displayProduct)

  // const ProductImageComp = displayProduct.image?.startsWith('http') ? ProductImageExternal : ProductImage
  const ProductImageComp = ProductImage

  return (
    <div className="basic-plan-summary">
      <ProductImageComp className="product-image" src={displayProduct.image}>
        {shouldShowRibbonMessage(displayProduct.ribbonMessage) ? (
          <div className="ribbon-wrapper-red">
            <div className="ribbon-red">{displayProduct.ribbonMessage.text}</div>
          </div>
        ) : null}
      </ProductImageComp>
      <div className="title">
        <h4>{displayName}</h4>
      </div>
      <div className="description">
        <div className="description__short">
          <span>{displayProduct.description}</span>
        </div>
        <BasicPlanBenefits id="basic-plan-benefits" benefits={displayProduct.benefits} />
        {(requireLicenses || isShowIconCheckLicenses) && !isBrochure ? (
          <div className="description__notification">
            <span>{MESSAGES.LICENSE_WIFI}</span>
          </div>
        ) : null}
      </div>
    </div>
  )
}

export const BasicPlanBenefits = ({ benefits }) => {
  return (
    <div className="description__highlight">
      <ul>
        {benefits.map((benefit) => (
          <li key={benefit}>
            <WordWraps>{benefit}</WordWraps>
          </li>
        ))}
      </ul>
    </div>
  )
}
